import React, { useEffect, useState, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "./GitaDaan.css";

import banner01 from "../../Pages/Gita-Daan/assets/gitajayantihome1.jpg";
import banner02 from "../../Pages/Gita-Daan/assets/gitajayantihome2.jpg";

import { Helmet } from "react-helmet-async";
import BookDonation from "./BookDonation/BookDonation";

import DonateViaUpi from "./DonateViaUpi/DonateViaUpi";
import AutoImageSlider from "../../Components/AutoImageSlider";
import imageslider1 from "./assets/imageslider1.jpg";
import imageslider2 from "./assets/imageslider2.jpg";
import imageslider3 from "./assets/imageslider3.jpg";
import imageslider4 from "./assets/imageslider4.jpg";
import imageslider5 from "./assets/imageslider5.jpg";

const GitaDaan = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [showMore, setShowMore] = useState(false);
  const [currentBanner, setCurrentBanner] = useState(0);
  const contentRef = useRef(null);

  const banners = [banner01, banner02];

  // Auto-slide 4s
  useEffect(() => {
    const interval = setInterval(() => {
      nextBanner();
    }, 4000);

    return () => clearInterval(interval);
  }, [currentBanner]);

  const nextBanner = () => {
    setCurrentBanner((prev) => (prev + 1) % banners.length);
  };

  const handleReadMoreToggle = () => {
    if (showMore) {
      contentRef.current.scrollIntoView({ behavior: "smooth" });
    }
    setShowMore(!showMore);
  };
  const slides = [
    {
      id: 1,
      title: "Annadaan Seva",
      image: imageslider1,
    },
    {
      id: 2,
      title: "Gau Seva",
      image: imageslider2,
    },
    {
      id: 3,
      title: "Visesh Navidya Seva",
      image: imageslider3,
    },
    {
      id: 4,
      title: "Spritual Discourses",
      image: imageslider4,
    },
    {
      id: 5,
      title: "Spritual Discourses",
      image: imageslider5,
    },
  ];

  return (
    <div>
      {/* ⭐ SEO + Social Meta */}
      <Helmet>
        <title>
          Gita Daan – Sponsor Bhagavad Gita Distribution | ISKCON Vijayawada
        </title>

        <meta
          name="description"
          content="Participate in Gita Daan and help distribute Bhagavad Gita to students, villages, schools, and families. Support ISKCON's mission to spread divine knowledge."
        />
        <meta
          name="keywords"
          content="Gita Daan, Bhagavad Gita donation, ISKCON Vijayawada, Gita distribution, sponsor Gita"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Gita Daan – Sponsor Bhagavad Gita Distribution"
        />
        <meta
          property="og:description"
          content="Support Gita Daan and help deliver the wisdom of Bhagavad Gita to thousands. Join ISKCON in spreading spiritual knowledge."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/gita-daan"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Gita Daan – Sponsor Bhagavad Gita Distribution"
        />
        <meta
          name="twitter:description"
          content="Gift the timeless wisdom of Bhagavad Gita through Gita Daan."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/gita-daan"
        />

        {/* Google Tag Manager */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-17470820924"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-17470820924');
          `}
        </script>
      </Helmet>

      <Header />

      {/* ⭐ Banner Carousel */}
      <div className="gita-banner-carousel">
        <div className="carousel-container">
          <div className="carousel-track">
            {banners.map((banner, index) => (
              <div
                key={index}
                className={`carousel-slide ${index === currentBanner ? "active" : ""}`}
              >
                <img
                  loading="lazy"
                  src={banner}
                  alt={`Gita Daan Banner ${index + 1}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ⭐ Page Content */}
      <div className="page-container" ref={contentRef}>
        <h1 className="page-title">Gita Jayanti Celebration</h1>

        <p className="page-text">
          Every year, ISKCON celebrates Gita Jayanti, the auspicious day when
          Lord Krishna imparted the timeless wisdom of the Bhagavad Gita to
          Arjuna on the battlefield of Kurukshetra. To commemorate this sacred
          occasion, ISKCON devotees around the world engage in the widespread
          distribution of the Bhagavad Gita, ensuring that its profound
          teachings reach as many people as possible. By sharing the Gita, we
          offer others the opportunity to deepen their devotion to Lord Krishna,
          live a life of purpose, and fulfill the true potential of this human
          form of life.
        </p>

        <p className="page-text">
          This is the call to action—just as Lord Krishna imparted this eternal
          wisdom to Arjuna, we now have the opportunity to pass it on to the
          world, helping people realize their true potential through the
          teachings of the Bhagavad Gita. The Bhagavad Gita is not just a book;
          it is a spiritual guide that offers practical solutions for living a
          righteous and fulfilling life.
        </p>

        {showMore && (
          <div className="read-more-content">
            <p>
              Lord Krishna guaranteed in Bhagavad Gita 18.68-69: "For one who
              explains this supreme secret to the devotees, pure devotional
              service is guaranteed, and at the end, he will come back to Me,
              Lord Krishna. There is no one in this world more dear to Me (Lord
              Krishna) than he, nor will there ever be one more dear."
            </p>

            <p>
              Achievement in 59 years of Service - ISKCON has distributed 60.25
              Crores of Bhagavad Gita and Srimad Bhagavatam and other Vedic
              Literature all over the World Goal of December 2025 - To
              distribute 50 lakhs of Bhagavad Gita in schools, colleges,
              villages and jails.
            </p>

            <p>
              We invite everyone to join us in spreading the divine wisdom of
              the Bhagavad Gita & be a part of an inspiring mission to place the
              Bhagavad Gita in public libraries, schools, tribal areas, and
              communities across India, and beyond. Your donation will help us
              share this timeless scripture, empowering students, communities,
              and individuals with the wisdom and guidance to live a life of
              purpose, peace, and spiritual fulfillment.
            </p>
          </div>
        )}

        <button className="read-more-btn" onClick={handleReadMoreToggle}>
          {showMore ? "Read Less" : "Read More"}
        </button>
      </div>

      <AutoImageSlider images={slides} />
      {/* <ImagesSlider /> */}
      <BookDonation />
      <DonateViaUpi />

      {/* Gentle Request */}
      <div className="mt-10 bg-gray-100 border rounded-lg p-6 text-center text-gray-700 text-sm md:text-base">
        Gentle Request! After donating via UPI/Bank/Paytm, please send a
        screenshot with your address & PAN details on WhatsApp{" "}
        <span className="font-semibold text-[#C61D21]">+91 9955685568</span> or
        email{" "}
        <span className="font-semibold text-blue-600">
          support@iskconvijayawada.org
        </span>
        .
      </div>

      <Footer />
    </div>
  );
};

export default GitaDaan;
